import React, {
    useEffect,
    useMemo,
    useState,
} from 'react';
import {
    useAppDispatch,
    useAppSelector,
} from '../../../app/hooks';
import Ornament1 from '../img/orn1.svg';
import {results} from '../texts/results';
import {questionList} from '../texts/questions';
import styles from '../Quiz.module.css';
import {
    goToStart,
    selectAnswers,
} from '../quizSlice';
import {Header} from './Header';
import Bg from '../img/cover.jpg'
import { CSSTransition } from 'react-transition-group';
import {Loader} from './Loader';
import {

    FacebookIcon,
    FacebookShareButton,
    TelegramIcon,
    TelegramShareButton,
    TwitterIcon,
    TwitterShareButton,
} from 'react-share';


const location = window.location.href.replace(/[^/]*$/, '');


export const Result = ()=>{
    const dispatch = useAppDispatch();

    const answers = useAppSelector(selectAnswers);

    const countAnswers = useMemo(()=> {
        const rightAns = answers.filter((item, index) => {
            return index>0 && item === questionList?.find(q => q.id === index)?.rightAnswerId
        });

        return rightAns.length
    },[answers]);


    const result = useMemo(()=>{
       return results.find(item => item.min<= countAnswers && item.max>=countAnswers)
    },[countAnswers])

    const [inProp, setInProp] = useState<boolean>(false);
    const [loading, setLoading] = useState(false);


    useEffect(() => {
        setInProp(true);
    }, [])

    const onGameReload = () => {
        dispatch(goToStart());
    }


    const createResult =()=>{
            return <><div className={`${styles.question} card` }>

                <div className = {styles.ornament}>
                    <img src={Ornament1} alt="" />
                </div>

            <div className={`${styles.result}`}>
                <div className = 'gra'>Ваші результати:</div>
                <br/>
                <div className= 'gra__under'>Ви отримали {countAnswers} правильн{countAnswers>1?'их':'у'} відповід{countAnswers>1?'ей':'ь'} з 10</div>
                <div className={styles.resultText}
                     dangerouslySetInnerHTML={{__html: result?.text|| ''}}></div>

                </div>
                <button onClick={() => onGameReload()} className={`${styles.button} ${styles.rightAnswer} ${styles.startButton}`}>
                    <div dangerouslySetInnerHTML={{__html: 'Грати знову!' || ''}}></div>
                </button>

                <br/>
                <p>Порадь пройти цей тест друзям: </p>

                <p className={styles.social}><FacebookShareButton url={location}>
                    <FacebookIcon size={40}/>
                </FacebookShareButton>
                    <TelegramShareButton url={location} color={'#1de5ac'}>
                        <TelegramIcon size={40}/>
                    </TelegramShareButton>
                    <TwitterShareButton url={location}>
                        <TwitterIcon size={40}/>
                    </TwitterShareButton>
                </p>

                <div className={styles.resultText}>
                    <span className={styles.author}>
                        Розробка: Олександра Яковина
                    </span>
                    <span className={styles.author}>
                        Веб-дизайн та ілюстрації: Влад Захаров
                    </span>
                    <span className={styles.author}>
                      Автор: Леся Панченко
                    </span>
                </div>
            </div>
    </>
        }


    return <>
        <div className={styles.questionContainer} style={{ backgroundImage: `url(${Bg})` }}>
            <Header />

            <CSSTransition in={inProp} timeout={1000} classNames="card">
                {loading ?    <div className='card'><Loader /></div> : createResult()}
            </CSSTransition>
        </div>
    </>
}
